import React from 'react';
import { Alert, useTheme, alpha } from '@mui/material';

interface ErrorAlertProps {
    error: string | null;
    onClose: () => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, onClose }) => {
    const theme = useTheme();

    if (!error) return null;

    return (
        <Alert 
            severity="error" 
            sx={{ 
                mb: 2,
                borderRadius: 1,
                backgroundColor: alpha(theme.palette.error.main, 0.1),
                color: theme.palette.error.main,
                border: 'none',
                '& .MuiAlert-icon': {
                    color: theme.palette.error.main,
                },
            }}
            onClose={onClose}
        >
            {error}
        </Alert>
    );
};

export default ErrorAlert; 